<div class="flex flex-row flex-wrap breadcrumbItems">
  <div *ngFor="let item of items; let last = last" class="flex flex-row items-center">

    <img *ngIf="item?.icon" [routerLink]="['/', tenant].concat(item.url)" [src]="item.icon" alt="icon" class="flex inline-block align-items cursor-pointer"/>

    <span *ngIf="item.action && !last" class="fs-12 mr-8 cursor-pointer" (click)="item.action()">{{ item.label | titlecase }} </span>

    <span *ngIf="!item?.url && !item?.click && !item?.icon && !item.action" class="fs-12 mr-8" [ngClass]="{'max-w-[300px]': item?.label?.length > 32}" [matTooltip]="item?.label?.length > 32 ? item?.label  : ''" [matTooltipClass]="'tooltip-inner above custom-db'" matTooltipPosition="above">
      {{ item?.label?.length > 32 ? (((item?.label | titlecase) | slice:0:32) + '…') : ((item?.label?.includes('-') ? item?.label?.split('-')[0].trim() : item?.label) | titlecase) }}
    </span>

    <span *ngIf="item?.click" class="fs-12 mr-8 cursor-pointer" (click)="itemClick(item)">
      {{item?.label.includes('-') ? (item?.label.split('-')[0].trim() | titlecase) : item?.label ? (item?.label | titlecase) : '-' }}
    </span>

    <a *ngIf="item?.url" [routerLink]="['/', tenant].concat(item.url)" [queryParams]="item.queryParams" class="fs-12 mr-8 no-underline">
      {{item?.label}}
    </a>

    <mat-icon svgIcon="chevron_right" *ngIf="!last" class="mr-8 icon-sm"></mat-icon>

  </div>
</div>
